import { useUserAuth } from 'state/userAuthContext';
import { stockOrdersRoutes } from './allRoutes';
import { Route, Switch } from 'react-router-dom';

const switchRoutes = (
    <Switch>
      {stockOrdersRoutes.map((prop, key) => {
        if (prop.layout === 'stock') {
          return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
        }
        return null;
      })}
    </Switch>
  );
const StockOrders = () => {
    const { user } = useUserAuth();
    return <> {user && switchRoutes} </>;
}

export default StockOrders